import {
  InspectorControlsAppearance,
  InspectorControlsGeneral,
  InspectorTabs,
} from '@components/inspector-tabs';
import Visibility from '@components/visibility';
import Label from '@components/block-label';
import {
  FocusableIcon,
  FocusableIconSwitcher,
} from '@components/focusable-block-icon';
import { title } from './block.json';
import classnames from 'classnames';

const {
  blockEditor: { useBlockProps, useInnerBlocksProps },
} = wp;

const DEFAULT_TAB_SLIDER_TAB_TEMPLATE = [
  [
    'b3rg/tab-slider-tab-nav',
    {},
    [['core/heading', { level: 3, placeholder: 'Tab title' }]],
  ],
  [
    'b3rg/tab-slider-tab-content',
    {},
    [
      [
        'core/paragraph',
        {
          placeholder: 'Tab content ...',
        },
      ],
    ],
  ],
];

const Edit = (props) => {
  const { attributes, setAttributes } = props;
  const { label, blockVisibility, enableFocusableIcon } = attributes;
  const blockProps = useBlockProps({
    className: classnames({
      'swiper-slide': true,
      disable: !blockVisibility,
      'has-focusable-icon': enableFocusableIcon,
    }),
  });
  const { children, ...innerBlockProps } = useInnerBlocksProps(blockProps, {
    allowedBlocks: ['b3rg/tab-slider-tab-nav', 'b3rg/tab-slider-tab-content'],
    templateLock: false,
    template: DEFAULT_TAB_SLIDER_TAB_TEMPLATE,
  });

  return (
    <>
      <InspectorTabs>
        <InspectorControlsGeneral>
          <Label {...{ label, setAttributes }} />
          <Visibility {...{ blockVisibility, setAttributes }} />
        </InspectorControlsGeneral>
        <InspectorControlsAppearance>
          <FocusableIconSwitcher
            {...{
              enableFocusableIcon,
              setAttributes,
            }}
          />
        </InspectorControlsAppearance>
      </InspectorTabs>
      <div {...innerBlockProps}>
        {enableFocusableIcon && (
          <FocusableIcon {...{ title, attributes, setAttributes }} />
        )}
        {children}
      </div>
    </>
  );
};

export default Edit;
